import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAlertTriangle, FiZap, FiBookOpen, FiBell, FiCheckCircle, FiTrendingDown, FiArrowDown } = FiIcons;

const steps = [
  { icon: FiAlertTriangle, color: 'bg-red-100 text-red-600 border-red-200', label: 'Failure Detected', desc: 'Learner clicks link or submits credentials in phishing sim' },
  { icon: FiZap, color: 'bg-orange-100 text-orange-600 border-orange-200', label: 'Risk Score Increased', desc: 'Phishing risk score auto-updated based on failure severity' },
  { icon: FiBookOpen, color: 'bg-blue-100 text-blue-600 border-blue-200', label: 'Training Assigned', desc: 'Targeted remedial module assigned with due date' },
  { icon: FiBell, color: 'bg-violet-100 text-violet-600 border-violet-200', label: 'Notifications Sent', desc: 'Learner, manager, and/or admin notified based on severity' },
  { icon: FiCheckCircle, color: 'bg-emerald-100 text-emerald-600 border-emerald-200', label: 'Training Completed', desc: 'Learner completes remedial module and passes assessment' },
  { icon: FiTrendingDown, color: 'bg-teal-100 text-teal-600 border-teal-200', label: 'Risk Adjusted', desc: 'Risk score reduced based on training score. Status reset.' },
];

const WorkflowTimeline = () => (
  <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6">
    <h3 className="text-sm font-semibold text-slate-700 mb-5">Reactive Training Workflow</h3>
    <div className="flex flex-col gap-0">
      {steps.map((step, i) => (
        <React.Fragment key={step.label}>
          <motion.div initial={{ opacity: 0, x: -12 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: i * 0.08 }}
            className="flex items-start gap-4">
            <div className="flex flex-col items-center">
              <div className={`w-10 h-10 rounded-xl border-2 flex items-center justify-center flex-shrink-0 ${step.color}`}>
                <SafeIcon icon={step.icon} className="text-base" />
              </div>
            </div>
            <div className="pb-1">
              <p className="text-sm font-semibold text-slate-800">{step.label}</p>
              <p className="text-xs text-slate-500 leading-relaxed">{step.desc}</p>
            </div>
          </motion.div>
          {i < steps.length - 1 && (
            <div className="flex items-center gap-4 py-1">
              <div className="w-10 flex justify-center">
                <SafeIcon icon={FiArrowDown} className="text-slate-300 text-sm" />
              </div>
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  </div>
);

export default WorkflowTimeline;